<script setup>
import { PhxCountdown } from '@phx-styleguides/rdu';
import { useCountdown } from '@phoenix/composables/components/useCountdown';

const props = defineProps({
  i18n: {
    type: Object,
    required: true,
  },
  targetUnixTime: {
    type: Number,
    required: true,
  },
  hideCta: {
    type: Boolean,
    default: false,
  },
  ctaContainerId: {
    type: String,
    required: true,
  },
});

const { isActive } = useCountdown(props.targetUnixTime, props.hideCta, props.ctaContainerId, 'force-hidden');
</script>

<template>
  <div>
    <phx-countdown v-if="isActive" :i18n="i18n" :target-unix-time="targetUnixTime" />
  </div>
</template>
